import * as React from "react";
import Img from "gatsby-image";
import { Parallax } from "react-scroll-parallax";

import { ContentfulBlock } from "../../graphql-types";
import Slider from "../slider";
import {
  Block as Wrapper,
  TextContainer,
  Text,
  ImageWrapper,
  ImageWrapperFull
} from "./style";

interface Props {
  block: ContentfulBlock;
}

function getType(block: ContentfulBlock) {
  if (block.content) {
    return "TEXT";
  }
  if (block.image && block.size === 100) {
    return "IMAGE_FULL";
  }
  if (block.image) {
    return "IMAGE";
  }
  if (block.slider) {
    return "SLIDER";
  }
}

function BlockText({ block }: Props) {
  return (
    <TextContainer>
      <Text
        color={block.textColor ? block.textColor.value : "black"}
        titleColor={block.titleColor ? block.titleColor.value : "black"}
        dangerouslySetInnerHTML={{
          __html: block.content.childMarkdownRemark.html
        }}
      />
    </TextContainer>
  );
}

function BlockImage({ block }: Props) {
  return (
    <ImageWrapper>
      <Img fluid={block.image.fluid} />
    </ImageWrapper>
  );
}

function BlockImageFull({ block }: Props) {
  if (block.parallax) {
    return (
      <ImageWrapperFull>
        <Parallax offsetYMax="-20%" offsetYMin="20%">
          <Img fluid={block.image.fluid} />
        </Parallax>
      </ImageWrapperFull>
    );
  }
  return <BlockImage block={block} />;
}

function Inner({ block }: Props) {
  const type = getType(block);

  switch (type) {
    case "TEXT": {
      return <BlockText block={block} />;
    }
    case "IMAGE": {
      return <BlockImage block={block} />;
    }
    case "IMAGE_FULL": {
      return <BlockImageFull block={block} />;
    }
    case "SLIDER": {
      return <Slider images={block.slider} />;
    }
    default:
      return null;
  }
}

export default function Block({ block }: Props) {
  return (
    <Wrapper color={block.color && block.color.value} size={block.size}>
      <Inner block={block} />
    </Wrapper>
  );
}
